import mtechPrograms from "../programDetails/mtechPrograms.json";
import onlineMtechPrograms from "../programDetails/onlineMtechPrograms.json";
import mscPrograms from "../programDetails/mscPrograms.json";
import phdPrograms from "../programDetails/phdPrograms.json";

export const getAllPrograms = () => {
  const items = [];
  const pushItems = (dataset, category, segment) => {
    Object.entries(dataset || {}).forEach(([key, p]) => {
      if (!p || !p.name) return;
      const id = p.id || key;
      items.push({
        id,
        name: p.name,
        category,
        categorySegment: segment,
        description: (p.about && p.about.description) ? p.about.description : ""
      });
    });
  };
  pushItems(mtechPrograms, "M.Tech", "progmtech");
  pushItems(onlineMtechPrograms, "Online M.Tech", "online-mtech");
  pushItems(mscPrograms, "M.Sc", "progms");
  pushItems(phdPrograms, "PhD", "progphd");

  items.sort((a, b) => a.name.localeCompare(b.name));
  return items;
};

export const getFirstProgram = () => {
  const all = getAllPrograms();
  return all.length ? all[0] : null;
};

export const getProgramById = (programId) => {
  const all = getAllPrograms();
  return all.find(p => p.id === programId) || null;
};
